import React from "react";
import {FaLocationDot, FaPhone} from "react-icons/fa6";
import socialMedia from "../Data/SocialMedia";

const Footer = () => {
    return (<footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white w-full">
        <div className="max-w-full mx-auto px-6 sm:px-4 py-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                {/* Company Info */}
                <div className="space-y-4 text-center">

                    <img src="../images/CompanyLogo.png" alt="Company Logo"
                         className="mx-auto mb-4 w-32 h-auto bg-white rounded-2xl"/>
                    <h1 className="text-3xl font-bold">
                        <span className="text-yellow-400 relative">Sun Pledge</span> Holdings
                    </h1>
                    <p className="italic text-gray-300">"Brighter Today, Greener Tomorrow..."</p>
                    <p className="text-gray-400 leading-relaxed">
                        A trusted leader in rooftop solar energy solutions, committed to sustainable energy and a
                        greener future.
                    </p>
                </div>

                {/* Quick Links */}
                <div className="space-y-4 text-center">
                    <h2 className="text-xl font-semibold relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-10 after:h-1 after:bg-yellow-400">
                        Quick Links
                    </h2>

                    <ul className="space-y-3">
                        {[{name: "About Us", href: "/about"}, {
                            name: "Services", href: "/services"
                        }, {name: "Domestic Projects", href: "/projects"}, {
                            name: "Commercial Projects", href: "/projects"
                        }, {name: "Solutions", href: "/privacy"}, {name: "Contact", href: "/contact"},].map((link) => (
                            <li key={link.name}>
                                <a
                                    href={link.href}
                                    className="text-gray-400 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block relative after:content-[''] after:absolute after:w-0 after:h-px after:bg-yellow-400 after:left-0 after:bottom-0 after:transition-all hover:after:w-full"
                                >
                                    {link.name}
                                </a>
                            </li>))}
                    </ul>
                </div>

                {/* Contact Details */}
                <div className="text-center space-y-4">
                    <h2 className=" text-xl font-semibold relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-10 after:h-1 after:bg-yellow-400">
                        Contact Us
                    </h2>
                    <ul className="space-y-4 text-sm">
                        <li className="flex justify-center text-gray-400">
                            <div className="flex flex-col space-y-2">
                                {[
                                    {name: "Anupama Jayasekara", number: "+94 74 181 4164"},
                                    {name: "Ravindu Rukmal", number: "+94 77 936 5857"},
                                    {name: "Priyantha Jayasekara", number: "+94 77 974 8015"}
                                ].map((phone) => (
                                    <a
                                        key={phone.number}
                                        href={`tel:${phone.number.replace(/ /g, '')}`}
                                        className="flex items-center text-gray-400 hover:text-white transition-all duration-300 hover:translate-x-1 relative after:content-[''] after:absolute after:w-0 after:h-px after:bg-yellow-400 after:left-0 after:bottom-0 after:transition-all hover:after:w-full"
                                    >
                                        <FaPhone className="text-yellow-400 mr-2"/>
                                        <span>{phone.name}: {phone.number}</span>
                                    </a>))}
                            </div>
                        </li>


                        <li className="flex items-center justify-center text-gray-400 space-x-2">
                            <FaLocationDot className="text-yellow-400"/>
                            <span>Address : No.230, Horana Rd, Bolgoda, Bandaragama</span>
                        </li>

                    </ul>
                </div>

                {/* Map & Social Media */}
                <div className="space-y-4 text-center">
                    <h2 className=" text-xl font-semibold relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-10 after:h-1 after:bg-yellow-400">
                        Find Us
                    </h2>
                    <div className="h-40 w-full rounded-lg overflow-hidden shadow-lg border border-gray-700">
                        <iframe
                            title="Sun Pledge office location"
                            src="https://www.google.com/maps?q=No.230%2C%20Horana%20Rd%2C%20Bolgoda%2C%20Bandaragama&output=embed"
                            width="100%"
                            height="100%"
                            style={{border: 0}}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade">
                        </iframe>
                    </div>
                    <div className="flex space-x-3 justify-center">
                        {socialMedia.map((social, index) => (<a
                            key={index}
                            href={social.href}
                            target={'_blank'}
                            rel="noreferrer"
                            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 border border-gray-600 text-white hover:bg-yellow-400 hover:text-gray-900 hover:-translate-y-1 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-400/20"
                        >
                            {social.icon}
                        </a>))}
                    </div>
                </div>
            </div>
        </div>
        <div className="bg-black bg-opacity-30 py-5 px-2 text-center text-gray-500 border-t border-gray-800">
            &copy; {new Date().getFullYear()} Sun Pledge Holdings | All Rights Reserved | Designed by SolarWeb Team
        </div>
    </footer>);
};

export default Footer;
